// extracted by mini-css-extract-plugin
module.exports = {"mulitpleDropdown":"view360EmployeesTabContent_mulitpleDropdown__1fO13","container":"view360EmployeesTabContent_container__2TgN4"};